import React from 'react';
import Menu from './Dashboard/Menu';
import './css/Dashboard.css';
import { Outlet } from 'react-router-dom';
import TopBar from './Dashboard/TopBar';

function Dashboard() {
  return (
    <div className="dashboard-layout">

      {/* Panel 1 - TopBar */}
      <div className="panel-topbar">
        <TopBar />
      </div>

      {/* Panel 2 - Menu */}
      <div className="panel-menu">
        <Menu />
      </div>

      {/* Panel 3 - Contenido */}
      <div className="panel-contenido">
        <Outlet />
      </div>

    </div>
  );
}

export default Dashboard;
